import * as React from "react";
import LinkHybrid from "./LinkHybrid";
import type { TypeLinkProps } from "./LinkTypes";

/**
 * Link component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system/typography props or a styled() extension).
 */
const Link = React.forwardRef<
  HTMLAnchorElement | HTMLButtonElement,
  TypeLinkProps
>((props, ref) => <LinkHybrid {...props} ref={ref} />);

Link.displayName = "Link";

export default Link;
